<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="$t('system::rbac::添加员工')"
    @close="onChange"
    :visible.sync="dialogVisible"
    destroy-on-close
    width="690px"
  >
    <div style="margin-bottom:16px;">
      <el-input style="width:210px" :placeholder="$t('system::team::search_name')" v-model="params.keywords"></el-input>
      <el-cascader
        style="width:210px;margin:0 14px"
        :placeholder="$t('system::team::placeholdere_team')"
        :options="teamList"
        v-model="params.teamId"
        :props="{ checkStrictly: false, value: 'id', label: 'name', children: 'childrens' }"
        clearable
      ></el-cascader>
      <el-button type="primary" @click="search">{{ $t('system::common::btn::search') }}</el-button>
      <el-button @click="reset">{{ $t('system::common::btn::reset') }}</el-button>
    </div>
    <z-table
      ref="multipleTable"
      :columns="columns"
      :data="satffList"
      :pagination="false"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      :height="465"
      selection
      :customDefault="{ height: '465px' }"
    ></z-table>
    <div class="footer_class" slot="footer" style="text-align: center; display: block">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button @click="sumbit" type="primary">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addAccountForRole } from '@/server/system'
import { teamList, teamStaff } from '@/server/team-manage'
export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    roleId: {
      type: [Number, String],
      default: ''
    }
  },
  watch: {
    visible(bool) {
      this.dialogVisible = bool
      if (bool) {
        this.getTeamList()
        this.getTeamStaff()
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      params: {
        teamId: [],
        keywords: ''
      },
      loading: false,
      teamList: [],
      satffList: [],
      selection: [],
      columns: [
        {
          prop: 'loginName',
          label: this.$t('system::rbac::账号姓名'),
          minWidth: '200px'
        },
        {
          prop: 'accountNumber',
          label: this.$t('system::rbac::账号'),
          minWidth: '200px'
        },
        {
          prop: 'team',
          label: this.$t('system::rbac::所属团队'),
          minWidth: '200px'
        }
      ]
    }
  },
  methods: {
    async getTeamStaff() {
      let params = {
        type: 0,
        pageNum: 1,
        pageSize: 1000,
        roleId: this.roleId
      }
      if (this.params.teamId.length) {
        params.type = 1
        params = { ...params, ...this.params }
        params.teamId = Array.isArray(params.teamId) ? params.teamId.pop() : params.teamId
      }
      if (this.params.keywords) {
        params = { ...params, keywords: this.params.keywords }
      }
      this.loading = true
      const { data } = await teamStaff(params)
      if (data.code === this.$code) {
        this.satffList = data.data.items
        this.multipleSelection(this.selection)
      }
      this.loading = false
    },
    async getTeamList() {
      const params = {
        pageNum: 1,
        pageSize: 10000
      }
      const { data } = await teamList(params)
      if (data.code === this.$code) {
        const fn = arr => {
          return arr.map(item => {
            if (item.childrens && item.childrens.length) {
              fn(item.childrens)
            } else if (item.childrens) {
              delete item.childrens
            }
            return item
          })
        }
        this.teamList = fn(data.data.items)
      }
    },
    search() {
      this.getTeamStaff()
    },
    reset() {
      this.params.keywords = ''
      this.params.teamId = []
      this.getTeamStaff()
    },
    handleSelectionChange(selection) {
      this.selection = selection
    },
    multipleSelection(list) {
      list.forEach(el => {
        this.$refs.multipleTable && this.$refs.multipleTable.$refs.elTable.toggleRowSelection(el)
      })
    },
    async save() {
      const data = await addAccountForRole({
        userIds: this.selection.map(el => el.userId),
        roleId: this.roleId,
        systemId: 3
      })
      if (data.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::add_success'))
        this.onChange()
        this.$emit('refresh')
      }
    },
    sumbit() {
      if (!this.selection.length) {
        this.$message.error('请选择员工')
        return
      }
      this.save()
    },
    onChange() {
      this.selection = []
      this.multipleSelection(this.selection)
      this.$emit('change', false)
    }
  }
}
</script>
<style scoped lang="scss"></style>
